import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { DataService } from "./data.service";

@Injectable()
export class RolesGuard {
  constructor(private router: Router, private dataService: DataService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const requiredPermission = route.data["requiredPermission"] as string;
    const requiredService = route.data["requiredService"] as string;
    const requiredProduct = route.data["requiredProduct"] as string;

    if (
      this.dataService.hasPermission(
        requiredPermission,
        requiredService,
        requiredProduct
      )
    ) {
      return true;
    } else {
      this.router.navigate(["home"]);
      return false;
    }
  }
}
